import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import { SwitchItem } from 'common/components/modules/multiply-switch';
import cx from 'classnames';

import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import Icon from 'common/components/elements/icons';

const RightSideHeader = ({
   desktopType,
   setDesktopType,
   isShowFullScreen,
   setIsShowFullScreen,
   hideWarningInfo,
   setHideWarningInfo,
}) => {
   return (
      <div
         className={ cx({
            'flex flex-col w-full': true,
            'px-4': 'desktop' === desktopType && isShowFullScreen,
         }) }
      >
         <div className='flex py-[14px]'>
            <div className='flex justify-center flex-1'>
               <div className='flex gap-3'>
                  <div className='h-10 w-10 flex items-center justify-center'>
                     <SwitchItem
                        iconSize='2xl'
                        icon='desktop'
                        checked={ desktopType === 'desktop' }
                        onClick={ () => setDesktopType('desktop')  }
                        newstyle
                     />
                  </div>
                  <div className='h-10 w-10 flex items-center justify-center'>
                     <SwitchItem
                        iconSize='2xl'
                        icon='mobile'
                        checked={ desktopType === 'mobile' }
                        onClick={ () => setDesktopType('mobile') }
                        newstyle
                     />
                  </div>
               </div>
               <div className='h-10 w-10'>
                  <Button
                     borderRadius='large'
                     iconName={ isShowFullScreen ? 'fullscreen-exit' : 'full-screen' }
                     backgroundColor='transparent'
                     fontIconColor='secondary'
                     classNames='border border-divider w-full h-full justify-center items-center hover:bg-grey-main'
                     textMarginX='0'
                     padding='0'
                     onClick={ () => setIsShowFullScreen(!isShowFullScreen) }
                  />
               </div>
            </div>
            <div className='flex px-2 items-center opacity-50'>
               <CheckboxLabel
                  name='hide_sample_content'
                  checked={ false }
                  className='flex justify-center'
                  textColor='major'
                  label='Hide sample content'
                  onChange={ () => {} }
                  padding='0'
                  textSize='base'
                  disabled
               />

            </div>
         </div>
         {
            !hideWarningInfo && (
               <div className='bg-warning-12 rounded-lg flex gap-4 p-4 justify-between items-center'>
                  <div className='flex gap-3'>
                     <div className='h-6 w-6 flex items-center justify-center bg-warning rounded-full'>
                        <Icon name='details' color='major-dark' size='base' />
                     </div>
                     <div className='flex flex-col gap-2'>
                        <span className='font-semibold text-warning text-base leading-[20px]'>Sample Content Only</span>
                        <span className='text-sm text-warning leading-[18px]'>We have populated this page with sample content. Please delete, or replace sample content with your own.</span>
                     </div>
                  </div>
                  <div className='h-9 w-9'>
                     <Button
                        iconName='close'
                        backgroundColor='transparent'
                        fontIconColor='secondary'
                        classNames='w-full h-full'
                        textMarginX='0'
                        padding='0'
                        onClick={ setHideWarningInfo }
                     />
                  </div>
               </div>
            )
         }
      </div>
   )
}

RightSideHeader.propTypes = {
   desktopType: PropTypes.string,
   setDesktopType: PropTypes.func,
   isShowFullScreen: PropTypes.bool,
   setIsShowFullScreen: PropTypes.func,
   setHideWarningInfo: PropTypes.func,
   hideWarningInfo: PropTypes.bool,
}

export default RightSideHeader;
